import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import { useSignupContext } from 'packages/signup/components/signupProvider';
import type { LearnMoreSurveyQuestionsValues } from 'packages/signup/components/explore/UnifiedLearnMoreJourneyQuestions';

export default function UnifiedLearnMoreJourneyQuestionsFormObserver() {
  const { values } = useFormikContext<LearnMoreSurveyQuestionsValues>();
  const {
    setWhoToPayComplete,
    setNumberStatesComplete,
    setPrevPayrollProviderComplete,
    setWhatToUseComplete,
    setWhatToUseFindYourPlanComplete,
    whoToPay,
    numberStates,
    prevPayrollProvider,
    whatToUse,
    whatToUseFindYourPlan,
  } = useSignupContext();

  useEffect(() => {
    if (values.whoToPay && values.whoToPay !== whoToPay) {
      setWhoToPayComplete(values.whoToPay);
    } else if (values.numberStates && values.numberStates !== numberStates) {
      setNumberStatesComplete(values.numberStates);
    } else if (values.prevPayrollProvider && values.prevPayrollProvider !== prevPayrollProvider) {
      setPrevPayrollProviderComplete(values.prevPayrollProvider);
    } else if (values.whatToUse && values.whatToUse !== whatToUse) {
      setWhatToUseComplete(values.whatToUse);
    } else if (
      values.whatToUseFindYourPlan &&
      values.whatToUseFindYourPlan !== whatToUseFindYourPlan
    ) {
      setWhatToUseFindYourPlanComplete(values.whatToUseFindYourPlan);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return null;
}
